import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FaCreditCard,
  FaMoneyBillWave,
  FaUniversity,
  FaMobileAlt,
  FaSpinner,
  FaChevronRight,
  FaTag,
} from "react-icons/fa";
import axios from "axios";
import env from "../../config.json";
import { sendNotificationBidNotAccepted } from "../../utils/functions/notification";
import releaseRidersFromBidLock from "../../utils/functions/riders";
import CabServices from "../../services/externalServices/cab/CabServices";
import CouponServices from "../../services/externalServices/coupon/CouponServices";
import TripServices from "../../services/externalServices/trip/TripServices";

const {PAYMENT_URL}=env;


const PaymentOptions = ({
  amount,
  tripId,
  riderid,
  bidPhoneNumbers,
  cabRequestId,
  bidFcmTokens,
  bid,
  autoStart = false,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  // const {
  //   amount,
  //   tripid,
  //   riderid,
  //   callingModule,
  //   disableCOD,
  //   disableOnline,
  //   disableCoupon,
  //   bidPhoneNumbers,
  //   cabRequestId,
  //   bidFcmTokens,
  //   bid,
  // } = location.state || {};

  const [selectedOption, setSelectedOption] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [isBackConfirmed, setIsBackConfirmed] = useState(false);
  const [isCouponApplying, setCouponApplying] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");
  const [paymentUpdatedToDB, setPaymentUpdatedToDB] = useState(false);
  const [showCouponInput, setShowCouponInput] = useState(false);

  console.log("trip id", tripId);
  const initiateUpiPayment = async () => {
    setIsLoading(true);
    if (!tripId) {
      console.warn("Trip ID not available yet. Retrying shortly...");
      return;
    }
    try {
      const response = await axios.post(
        // "http://localhost:8080/initiatePayment",
        // "https://cruze-adminserver.onrender.com/initiatePayment",
        PAYMENT_URL,
        {
          // const response = await axios.post("https://cruze-adminserver.onrender.com/initiatePayment", {
          amount: amount, // Amount in rupees
          mobileNumber: bidPhoneNumbers,
          tripId: tripId,
        }
      );

      const data = response.data;
      console.log("data", data);
      if (data.success) {
        sessionStorage.setItem(
          "merchantTransactionId",
          data.merchantTransactionId
        );
        setTimeout(() => {
          window.location.href = data.data.instrumentResponse.redirectInfo.url;
        }, autoStart ? 0 : 1500);
        // window.location.href = data.url;  // Redirect to payment page
      } else {
        alert("Payment initiation failed. Please try again.");
      }
    } catch (error) {
      console.error("Error initiating payment:", error);
      alert("Payment initiation failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (autoStart && tripId && amount) {
      initiateUpiPayment();
    }
    // Auto-start is intentionally evaluated once when the route is opened.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoStart]);

  // Handle cancel action
  const handleCancel = async () => {
    try {
      if (bid && Object.keys(bid).length > 0) {
        await Promise.all([
          sendNotificationBidNotAccepted({
            cabRequestId,
            fcmTokens: bidFcmTokens,
            phoneNumbers: [bidPhoneNumbers],
          }),
          releaseRidersFromBidLock(bidPhoneNumbers),
          CabServices.update(cabRequestId, {
            isLock: true,
            status: "Cancel By User",
          }),
        ]);
      } else {
        await CabServices.update(cabRequestId, {
          isLock: true,
          status: "Cancel By User",
        });
      }
      navigate("/");
    } catch (error) {
      console.error("Error in handleCancel:", error);
    }
  };

  const handlePaymentOptionSelect = (option) => {
    setSelectedOption(option);

    if (option === "upi") {
      setIsLoading(true); // Show the loader during UPI payment
      setTimeout(() => {
        initiateUpiPayment();
      }, 500); // Optional slight delay for a smoother effect
    } else {
      alert(`Payment of ₹${amount} successful via ${option}`);
      navigate("/success");
    }
  };

  // const validateCouponCode = (code) => {
  //   console.log("Coupon Code Applied:", code);
  //   alert(`Coupon ${code} applied successfully!`);
  //   setShowCouponModal(false);
  // };

  const handleConfirmPayment = () => {
    if (!selectedOption) {
      alert("Please select a payment method.");
      return;
    }

    if (selectedOption === "upi") {
      initiateUpiPayment();
    } else {
      alert(`Payment of ₹${amount} successful via ${selectedOption}`);
      navigate("/success");
    }
  };

  useEffect(() => {
    const handleBackPress = (event) => {
      event.preventDefault();
      setModalVisible(true);
    };

    window.addEventListener("popstate", handleBackPress);

    return () => {
      window.removeEventListener("popstate", handleBackPress);
    };
  }, []);

  async function successCallback(responseData) {
    console.log("UPI payment successful", responseData);
    console.info("Updating invoice in the background...", tripId);

    try {
      // Wait for the invoice update before navigating
      const res = await TripServices.updateInvoice(tripId);
      console.info("Invoice update successful.");

      if (res.success) {
        navigate("/booking-status", {
          state: {
            tripId: tripId,
            status: responseData.responseCode,
          },
        });
      }
      // Navigate only after the invoice update completes
    } catch (error) {
      console.error("Failed to update invoice:", error);
      alert("Failed to update the invoice. Please try again.");
    }
  }

  const updateTripPaymentCoupon = async (option, couponCode) => {
    try {
      const currentDate = new Date();
      console.info(
        "Updating payment status to the database - started.",
        couponCode
      );

      const tripid = tripId;

      // console.error('=========================riderid-------------------', option, tripid, paymentData);

      const updateData = {
        payment: "coupon",
        paymentStatus: "completed",
        paymentDetails: {
          amount: amount,
          state: "COMPLETED",
          responseCode: "SUCCESS",
          couponCode: couponCode,
          paymentDate: currentDate,
        },
      };

      console.error(
        "updateData-----&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&",
        updateData
      );

      // We need to use directly instead of the socket
      const response = await TripServices.update(tripid, updateData);
      console.error("response===================", response);
      // dispatch(updatePaymentMode(response.trip.payment));

      console.error("response===================", response);
      successCallback(updateData.paymentDetails); // Trigger the callback

      setPaymentUpdatedToDB(true);
      console.info("Updating payment status to the database - ended.");

      setCouponApplying(false);
    } catch (error) {
      setPaymentUpdatedToDB(false);
      console.error("Error updating trip payment status", error);
      setCouponApplying(false);
    } finally {
      setPaymentUpdatedToDB(true);
      // setCouponApplying(false)
    }
  };

  const validateCouponCode = async (couponCode) => {
    try {
      // API Call to validate the coupon code

      setCouponApplying(true);
      console.error(" in the validateCouponCode==================", couponCode);

      const code = couponCode;

      // Prepare the payload to send to the backend
      const payload = { coupcode: couponCode };
      const response = await CouponServices.validate(payload);

      console.error("=============== response ===========", response);

      if (response.message === "Coupon validated successfully") {
        setValidationMessage("Coupon applied successfully!");
        setShowCouponModal(false);

        console.warn("in the validate coupon=========", code);

        // Proceed with COD payment
        updateTripPaymentCoupon("coupon", code);
        // setShowFeedback(true);
        // LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
      } else {
        setCouponApplying(false);
        setValidationMessage("Invalid coupon code.");
      }
    } catch (error) {
      console.error("Error validating coupon:", error);
      setValidationMessage("An error occurred. Please try again.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      {isLoading || autoStart ? (
        <div className="flex justify-center items-center h-full">
          <FaSpinner className="animate-spin text-4xl text-blue-600" />
          <p className="ml-3">
            {autoStart ? "Redirecting to PhonePe..." : "Processing Payment..."}
          </p>
        </div>
      ) : (
        <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-lg p-8">
          <div className="text-center mb-6">
            <h2 className="text-2xl font-semibold text-gray-800">
              Payment Options
            </h2>
            <p className="text-gray-500">
              Choose your preferred payment method
            </p>
          </div>

          <div className="flex justify-between items-center bg-gray-50 p-4 rounded-lg mb-6">
            <span className="text-lg font-semibold text-gray-700">
              Amount Payable:
            </span>
            <span className="text-2xl font-bold text-green-600">
              ₹ {amount}
            </span>
          </div>

          <div className="space-y-4">
            {/* <div
              className={`flex items-center justify-between p-4 border rounded-lg cursor-pointer transition ${
                selectedOption === "cod" ? "border-blue-500 bg-blue-100" : "border-gray-300"
              }`}
              onClick={() => handlePaymentOptionSelect("cod")}
            >
              <FaMoneyBillWave className="text-green-500 text-2xl" />
              <span className="text-lg font-medium">Cash on Delivery (COD)</span>
              <FaChevronRight className="text-gray-600" />
            </div> */}

            <div className="mb-6">
              {showCouponInput ? (
                <div className="flex flex-col space-y-3">
                  <div className="flex items-center space-x-2">
                    <input
                      type="text"
                      placeholder="Enter Coupon Code"
                      value={couponCode}
                      onChange={(e) => setCouponCode(e.target.value)}
                      className="border rounded-lg p-2 w-full"
                    />
                    <button
                      onClick={() => validateCouponCode(couponCode)}
                      className="bg-blue-500 text-white px-4 py-2 rounded-lg"
                    >
                      {isCouponApplying ? "Applying..." : "Apply"}
                    </button>
                  </div>

                  {/* Validation Message */}
                  {validationMessage && (
                    <p
                      className={`text-sm ${
                        validationMessage.includes("✅")
                          ? "text-green-500"
                          : "text-red-500"
                      }`}
                    >
                      {validationMessage}
                    </p>
                  )}
                </div>
              ) : (
                <button
                  onClick={() => setShowCouponInput(true)}
                  className="flex items-center space-x-2 text-blue-600"
                >
                  <FaTag />
                  <span>Do you have a coupon?</span>
                </button>
              )}
            </div>

            {/* <div
              className={`flex items-center justify-between p-4 border rounded-lg cursor-pointer transition ${
                selectedOption === "upi" ? "border-blue-500 bg-blue-100" : "border-gray-300"
              }`}
              onClick={() => handlePaymentOptionSelect("upi")}
            >
              <FaCreditCard className="text-blue-500 text-2xl" />
              <span className="text-lg font-medium">Pay by UPI</span>
              <FaChevronRight className="text-gray-600" />
            </div> */}

            <div
              className={`flex items-center justify-between p-4 border rounded-lg transition ${
                selectedOption === "upi"
                  ? "border-blue-500 bg-blue-100"
                  : "border-gray-300"
              } ${
                !tripId || isLoading
                  ? "opacity-50 cursor-not-allowed"
                  : "cursor-pointer"
              }`}
              onClick={() => {
                if (tripId && !isLoading) {
                  handlePaymentOptionSelect("upi");
                }
              }}
            >
              <div className="flex items-center space-x-3">
                <FaCreditCard className="text-blue-500 text-2xl" />
                <span className="text-lg font-medium">Pay by UPI</span>
              </div>

              {isLoading ? (
                <FaSpinner className="animate-spin text-blue-500 text-xl" />
              ) : (
                <FaChevronRight className="text-gray-600" />
              )}
            </div>
          </div>

          {/* <div className="flex justify-between mt-8">
            <button
              className="bg-green-600 text-white px-6 py-3 rounded-lg"
              onClick={handleConfirmPayment}
            >
              Confirm Payment
            </button>
            <button
              className="bg-red-500 text-white px-6 py-3 rounded-lg"
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div> */}
        </div>
      )}
    </div>
  );
};

export default PaymentOptions;
